import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { getIconByAttachmentType } from '@core/src/nedoShared/features/chat/utils/getIconByAttachmentType';
import styles from './PostVisitsAttachment.module.scss';
export const PostVisitsAttachment = ({ attachment, containerClass, onAttachmentClick, }) => {
    const { t } = useTranslation();
    const getType = (type) => {
        if (!type)
            return [];
        if (type === 'post_visit_notes') {
            return ['post_visit_note_document_type'];
        }
        if (type === 'medication_prescription') {
            return ['medication_prescription_document_type'];
        }
        return [];
    };
    return (_jsx("div", Object.assign({ className: containerClass, onClick: () => onAttachmentClick(getType(attachment.type)) }, { children: _jsxs("div", Object.assign({ className: styles.cardClient }, { children: [_jsx("div", Object.assign({ className: styles.checkMark }, { children: _jsx(Icon, { type: "checkGreen" }) })), _jsx("div", Object.assign({ className: styles.icon }, { children: getIconByAttachmentType(attachment.type) })), _jsx("div", Object.assign({ className: styles.text }, { children: t(`label.${attachment.type}`) }))] })) })));
};
